<template>
    <div id="chuangCompetative">
        <div class="row overwrite-row competative-bg clearfix hide-on-med-and-down">
            <div class="competative-container-lists col m6 l6 xl6 offset-m6 offset-l6 offset-xl6" >
 
                <!-- <ul :class="{'animated rollIn': !isAnimateChangeLanguageOn, 
                        'animated rollOut': isAnimateChangeLanguageOn}"> -->
                         
                <ol :class="{}">
                    <h5>{{ competativeTitleLanguages[selectedLanguage] }}</h5>
                    <li  v-for="item in competativeLists[selectedLanguage]" >{{ item }}</li>
                </ol>
            </div>
            <div id="coreLink">

            </div>
        </div>
        <div class="row overwrite-row competative-bg-mobile clearfix hide-on-large-only">
            <div :class="{'competative-container-lists col s12 m12 l6 xl6': true, 
                                                        'english-layout': selectedLanguage == 2}" >
                <div class="competitive-mobile-list-container">
                    <ol>
                        <h5>{{ competativeTitleLanguages[selectedLanguage] }}</h5>
                        <li  v-for="item in competativeLists[selectedLanguage]" >{{ item }}</li>
                    </ol>
                </div>

            </div>
        </div>
        <div id="coreLinks">

        </div>
    </div>

</template>

<script>
    export default {
        
        data() {
            return {
                isPageStartAnimation: false,
                isAnimateChangeLanguageOn: false,
                competativeTitleLanguages: ['競爭優勢', '竞争优势', 'COMPETITIVE ADVANTAGE'],
                competativeLists: 
                [
                    [
                        '遊戲產業高度成長，亞太地區每年產值增加40%以上',
                        '集聚多位國內資深軟體工程師及技術總監',
                        '網路遊戲技術皆自行開發，技術卓越',
                        '目前主要在東南亞拓建市場，未來將全球化佈局',
                        '背景雄厚，資金健全', 
                        '創作自己的職涯生活，提供充滿競爭力的薪酬'
                    ],
                    [
                        '游戏产业高度成长，亚太地区每年产值增加40%以上',
                        '集聚多位国内资深软件工程师及技术总监',
                        '网络游戏技术皆自行开发，技术卓越',
                        '目前主要在东南亚拓建市场，未来将全球化布局',
                        '背景雄厚，资金健全',
                        '创作自己的职涯生活，提供充满竞争力的薪酬',
                    ],

                    [
                        'Fast growth in the gaming industry. The annual output of the  gaming industry in  Asia-Pacific has increased 40%.',
                        'Conglomeration of senior software engineers and chief technical officer at home and abroad.',
                        'We develop online games independently with outstanding technology',
                        'As for now we are  expanding our market in  South East Asia. In the near future, we have plans to globalize our market.',
                        'Abundant technical background and solid financial strength.',
                        'Set your own career path and have a competitive compensation.',
                    ]
                ],
            selectedLanguage: 0
            }
        },
        methods: {
            test(){
                console.log(true)
            },
            startChangeLangAnimation(){
                let _this = this;
                this.isAnimateChangeLanguageOn = true;
                this.selectedLanguage = parseInt(e);
            },
            startPageAnimation(){
                this.isPageStartAnimation = true;
                timeout
            }
        },
        mounted: function() {
            let _this = this;

            this.$root.$on('languageChange', function(e){
                _this.selectedLanguage = parseInt(e);
            })
            this.$root.$off('animageChangeLanguage', function(e){
                 _this.startChangeLangAnimation();
            })

            window.addEventListener('resize', function(e){
                let h = document.getElementById('chuangCompetative').offsetHeight;
                _this.$root.$emit('updateCompSize', h)
                console.log(h)
            });
            window.addEventListener('load', function(e){
                let h = document.getElementById('chuangCompetative').offsetHeight;
                _this.$root.$emit('updateCompSize', h)
                console.log(h)
            });

        },
        created: function() {


        }
    }
</script>

<style lang="less" scoped>
@import url('../assets/css/base.less');

    #coreLinks {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 4.3rem;
        
    }
    #chuangCompetative {
        position: relative;
        min-width: @min-width;
        background: url('../assets/images/competitive-bg.png') no-repeat bottom;
        background-size: 100% 100%;
        width: 100%;

        @media @768 {
            background: url('../assets/images/competitive-bg.png') no-repeat center;
            background-size: 100% 100%;
        }
        @media @479 {
            background: url('../assets/images/competitive-bg.png') no-repeat bottom;
            background-size: 100%;
        }
    }
    .competative-bg-mobile {
        // padding: 3rem;
    }
    .competative-bg {
        background: url('../assets/images/competative-bg-pc.png') no-repeat left;
        background-size: cover;
        height: inherit;
        padding: 3rem;
    }
    .overwrite-row {
        margin-bottom: none!important;
    }
    .competative-container-lists {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important;
        margin-left: 1rem;
        margin-right: 1rem;
        color: #535353;
        @media @990 {
            padding-top: 5rem !important;
            padding-bottom: 50rem !important;
        }
        @media @768 {
            padding-top: 5rem !important;
            padding-bottom: 40rem !important;
        }
        @media @479 {
            padding-top: 2rem !important;
            padding-bottom: 13rem !important;

        }

        h5 {
            margin-bottom: 2rem;
            text-align: left;
            font-size: @cons-main-text-size-1920;
            color: #535353;
            @media @1920 {
                font-size: @cons-main-text-size-1920;
                text-align: left;
            }
            @media @1600 {
                font-size: @cons-main-text-size-1920;
                text-align: left;
            }
            @media @1400 {
                font-size: @cons-main-text-size-1920;
                text-align: left;
            }
            @media @1200 {
                font-size: @cons-main-text-size-1920;
                text-align: left;
            }
            @media @990 {
                font-size: @cons-main-text-size-1920;
                text-align: center;
            }
            @media @768 {
                font-size: @cons-main-text-size-1920;
                text-align: center;
            }
            @media @479 {
                font-size: @cons-main-text-size-1920;
                text-align: center;
            }
        }
        ol {
            list-style-image: url('../assets/images/right-dotted-arrow.png');
            padding-left: 5rem;
            li {
                font-size: @cons-description-text-size-1920;
                line-height: 4rem;
                margin-left: 1.4rem;
                    @media @1920 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 4rem;
                    }
                    @media @1600 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 3rem;
                    }
                    @media @1400 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 3rem;
                    }
                    @media @1200 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 3rem;
                    }
                    @media @990 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 3rem;
                    }
                    @media @768 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 3rem;                        
                    }
                    @media @479 {
                        font-size: @cons-description-text-size-1920;
                        line-height: 3rem;                      
                    }
                }
            }
        div {
            width: 35rem;
            margin: 0 auto;
            font-size: @cons-description-text-size-1920;
            @media @1920 {
                font-size: @cons-description-text-size-1920;
                width: 35rem;
            }
            @media @1600 {
                font-size: @cons-description-text-size-1920;
                width: 35rem;
            }
            @media @1400 {
                font-size: @cons-description-text-size-1920;
                width: 35rem;
            }
            @media @1200 {
                font-size: @cons-description-text-size-1920;
                width: 35rem;               
            }
            @media @990 {
                font-size: @cons-description-text-size-1920;
                width: 35rem; 
            }
            @media @768 {
                font-size: @cons-description-text-size-1920;
                width: 35rem;       
            }
            @media @479 {
                font-size: @cons-description-text-size-1920;
                width: 20rem;                
            }
            @media @360 {
                width: 18rem;  
            }
            @media @320 {
                width: 17rem;  
            }
            ol {
                li {
                    line-height: 1.7rem;
                    margin-bottom: 3rem;
                    margin-top: 3rem;
                    @media @990 {
                        line-height: 1.7rem;
                        margin-top: 2rem;
                        margin-bottom: 2rem;
                        margin-top: 1rem;
                    }
                    @media @768 {
                        line-height: 1.7rem;
                        margin-bottom: 2rem;
                        margin-top: 1rem;
                    }
                    @media @479 {
                        line-height: 1.7rem;
                        margin-top: 1rem;
                        margin-bottom: 0rem;
                    }
                }
            }
        }
    }
    .english-layout {
        @media @479 {
            padding-bottom: 12rem;
        }
    }
    .competitive-mobile-list-container {
        ol {
            padding: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ChuangCompetitive.vue